module.exports = __webpack_public_path__ + "static/media/question-mark.6c8e82a6.svg";